"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INITIAL_STATE = void 0;

var _reduxActions = require("redux-actions");

var _utils = require("../lib/utils");

var _constants = require("../constants");

var _handleActions;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = _objectSpread({
  // Set annotation color to random selection
  annotationColor: _constants.ANNOTATION_COLOR_PALETE[0].hex,
  annotationLocation: undefined,
  commentsListMinimized: false,
  guestUserLoginToastInfo: null,
  isPlacingAnnotation: false,
  locale: 'en-US',
  annotatingItmId: undefined,
  registeredSectionIds: [],
  showAnnotationMask: false,
  viewingUnmapped: false,
  guestSessionState: undefined,
  guestSessionRestoreCount: _constants.GUEST_SESSION_REFRESH_LIMIT
}, (0, _utils.loadFromLocalStorage)("".concat(_constants.PREFIX, ":context")));

exports.INITIAL_STATE = INITIAL_STATE;
var COLOR_PREFERENCE_LOCAL_STORAGE_KEY = "".concat(_constants.PREFIX, "-annotation-color-preferences");
/**
 * Reducer to clear context
 * @returns {undefined}
 */

var contextClear = function contextClear() {
  return INITIAL_STATE;
};
/**
 * Reducer to handle setting the annotation mode
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var contextSetAnnotationMode = function contextSetAnnotationMode(state, action) {
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    annotatingItmId: action.itmId || (state.annotationLocation ? state.annotatingItmId : undefined),
    isPlacingAnnotation: Boolean(action.isPlacingAnnotation),
    newAnnotationType: action.newAnnotationType || state.newAnnotationType,
    showAnnotationMask: Boolean(action.showAnnotationMask)
  });

  var annotationColor;
  var colorPreferenceData = (0, _utils.loadFromLocalStorage)(COLOR_PREFERENCE_LOCAL_STORAGE_KEY) || {};
  annotationColor = colorPreferenceData[action.newAnnotationType];

  if (!annotationColor) {
    switch (action.newAnnotationType) {
      case 'highlight':
        annotationColor = _constants.ANNOTATION_COLOR_PALETE[2].hex;
        break;

      case 'insert':
        annotationColor = _constants.ANNOTATION_COLOR_PALETE[5].hex;
        break;

      default:
        annotationColor = _constants.ANNOTATION_COLOR_PALETE[0].hex;
    }
  }

  if (action.isPlacingAnnotation && !state.annotationLocation) {
    newState.annotationColor = annotationColor;
  }

  return newState;
};
/**
 * Sets the id of a comment associated with the selected annotation.
 * @param {Object} state - current state of store
 * @param {Object} action - action sent to the reducer
 * @return {undefined}
 */


var setAnnotatingCommentId = function setAnnotatingCommentId(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    annotatingItmId: action.id
  });
};
/**
 * Reducer to handle saving the location of the newly placed annotating
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var contextSaveAnnotationLocation = function contextSaveAnnotationLocation(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    annotationLocation: action.location
  });
};
/**
 * Reducer to handle saving the color of the newly placed annotation
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var contextSaveAnnotationColor = function contextSaveAnnotationColor(state, action) {
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    annotationColor: action.color
  });

  if (newState.annotationLocation) {
    newState.annotationLocation.coordinates.strokeColor = newState.annotationColor;
  }

  var colorPreferenceData = (0, _utils.loadFromLocalStorage)(COLOR_PREFERENCE_LOCAL_STORAGE_KEY) || {};
  colorPreferenceData[state.newAnnotationType] = action.color;
  (0, _utils.saveToLocalStorage)(COLOR_PREFERENCE_LOCAL_STORAGE_KEY, colorPreferenceData);
  return newState;
};
/**
 * Reducer to handle saving the location of the focused input
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var contextSaveFocusedInputInfo = function contextSaveFocusedInputInfo(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    focusedInputInfo: _objectSpread(_objectSpread({}, state.focusedInputInfo), action.focusedInputInfo)
  });
};
/**
 * Updates store with new commentsListMinimized state.
 * @param {Object} state - current state of store
 * @param {Object} action - action sent to the reducer
 * @return {Object} new state of store
 */


var contextSetCommentsListMinimized = function contextSetCommentsListMinimized(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentsListMinimized: action.commentsListMinimized
  });
};
/**
 * Reducer to handle saving the image coordinates of placed annotation
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var contextSaveImageCoordinatesInfo = function contextSaveImageCoordinatesInfo(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    imageCoordinatesInfo: action.imageCoordinatesInfo
  });
};
/**
 * Reducer to handle a successfully posted comment
 * @param {object} state - current state of store
 * @returns {undefined}
 */


var contextClearAnnotation = function contextClearAnnotation(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    annotationLocation: undefined,
    isPlacingAnnotation: false,
    annotatingItmId: undefined,
    newAnnotationType: undefined
  });
};
/**
 * Reducer to handle saving a clicked annotation ID
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var contextSetClickedAnnotation = function contextSetClickedAnnotation(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    clickedAnnotation: action.annotationId
  });
};
/**
 * Reducer to handle saving a requested comment ID to show
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {object} new state object
 */


var contextSetShowCommentId = function contextSetShowCommentId(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showCommentId: action.cmtId
  });
};
/**
 * Reducer to set user data on success
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {undefined}
 */


var contextCreateGuestUserSessionSuccess = function contextCreateGuestUserSessionSuccess(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    imsData: action.data,
    guestSessionState: 'valid',
    guestSessionRestoreCount: state.guestSessionRestoreCount - 1
  });
};
/**
 * Reducer to reset guest user data
 * @param {object} state - current state of store
 * @returns {undefined}
 */


var contextResetGuestUserSession = function contextResetGuestUserSession(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    imsData: {},
    guestSessionState: undefined,
    guestSessionRestoreCount: _constants.GUEST_SESSION_REFRESH_LIMIT
  });
};
/**
 * Reducer to set guest user session state
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {undefined}
 */


var contextSetGuestUserSessionState = function contextSetGuestUserSessionState(state, action) {
  var newSessionState = action.sessionState;

  var newState = _objectSpread(_objectSpread({}, state), {}, {
    guestSessionState: newSessionState
  });

  if (newSessionState === 'expired') {
    newState.guestSessionRestoreCount = _constants.GUEST_SESSION_REFRESH_LIMIT;
  }

  return newState;
};
/**
 * Reducer to set user data on error
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {undefined}
 */


var contextRegisterSectionid = function contextRegisterSectionid(state, action) {
  var currentSectionIds = state.registeredSectionIds;

  if (action.isAdd) {
    currentSectionIds.push(action.sectionId);
  } else {
    var sectionIdIndex = currentSectionIds.indexOf(action.sectionId);
    currentSectionIds.splice(sectionIdIndex, 1);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    registeredSectionIds: _toConsumableArray(currentSectionIds)
  });
};
/**
 * Reducer to set guest user login toast data
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {undefined}
 */


var contextSetGuestUserLoginToastInfo = function contextSetGuestUserLoginToastInfo(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    guestUserLoginToastInfo: action.data
  });
};
/**
 * Reducer to set guest user login toast data
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {undefined}
 */


var contextSetUnmappedView = function contextSetUnmappedView(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    viewingUnmapped: action.viewingUnmapped || false
  });
};

var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.CONTEXT_CLEAR, contextClear), _defineProperty(_handleActions, _constants.CONTEXT_SAVE_ANNOTATION_COLOR, contextSaveAnnotationColor), _defineProperty(_handleActions, _constants.CONTEXT_SAVE_ANNOTATION_LOCATION, contextSaveAnnotationLocation), _defineProperty(_handleActions, _constants.CONTEXT_SAVE_IMAGE_COORDINATES_INFO, contextSaveImageCoordinatesInfo), _defineProperty(_handleActions, _constants.CONTEXT_CREATE_GUEST_USER_SESSION.SUCCESS, contextCreateGuestUserSessionSuccess), _defineProperty(_handleActions, _constants.CONTEXT_CREATE_GUEST_USER_SESSION.ERROR, contextResetGuestUserSession), _defineProperty(_handleActions, _constants.CONTEXT_REGISTER_SECTION_ID, contextRegisterSectionid), _defineProperty(_handleActions, _constants.CONTEXT_SET_ANNOTATION_MODE, contextSetAnnotationMode), _defineProperty(_handleActions, _constants.CONTEXT_SET_CLICKED_ANNOTATION, contextSetClickedAnnotation), _defineProperty(_handleActions, _constants.CONTEXT_SET_SHOW_COMMENT_ID, contextSetShowCommentId), _defineProperty(_handleActions, _constants.COMMENTS_FILTER_CLEAR, contextSetUnmappedView), _defineProperty(_handleActions, _constants.COMMENTS_EDIT.ERROR, contextClearAnnotation), _defineProperty(_handleActions, _constants.COMMENTS_EDIT.SUCCESS, contextClearAnnotation), _defineProperty(_handleActions, _constants.COMMENTS_POST.SUCCESS, contextClearAnnotation), _defineProperty(_handleActions, _constants.UPDATE_ANNOTATION.SUCCESS, contextClearAnnotation), _defineProperty(_handleActions, _constants.UPDATE_ANNOTATION.ERROR, contextClearAnnotation), _defineProperty(_handleActions, _constants.COMMENTS_TOGGLE_RESOLVED, contextSaveAnnotationLocation), _defineProperty(_handleActions, _constants.CONTEXT_SET_GUEST_USER_LOGIN_TOAST_INFO, contextSetGuestUserLoginToastInfo), _defineProperty(_handleActions, _constants.CONTEXT_SAVE_FOCUSED_INPUT_INFO, contextSaveFocusedInputInfo), _defineProperty(_handleActions, _constants.CONTEXT_SET_COMMENTS_LIST_MINIMIZED, contextSetCommentsListMinimized), _defineProperty(_handleActions, _constants.CONTEXT_SET_UNMAPPED_VIEW, contextSetUnmappedView), _defineProperty(_handleActions, _constants.SET_ANNOTATING_COMMENT_ID, setAnnotatingCommentId), _defineProperty(_handleActions, _constants.CONTEXT_SET_GUEST_USER_SESSION_STATE, contextSetGuestUserSessionState), _defineProperty(_handleActions, _constants.CONTEXT_RESET_GUEST_USER_SESSION, contextResetGuestUserSession), _defineProperty(_handleActions, _constants.COMMENTS_RESOLVE.START, contextClearAnnotation), _handleActions), INITIAL_STATE);

exports.default = _default;